<div class="search-container" #searchContainer [ngClass]="{ 'presentation-mode': isPresentationMode }">
  <p-autoComplete
    [(ngModel)]="searchInputValue"
    [placeholder]="'globalSearchPlaceholder' | transloco"
    [group]="true"
    [suggestions]="suggestionResults"
    [showClear]="true"
    (onSelect)="selectItem()"
    (onFocus)="showDropDown()"
    (onKeyUp)="onKeyUp($event)"
    (completeMethod)="updateSuggestions()"
    (onClear)="resetCurrentSearchResult()"
    scrollHeight="500"
    [cpakTrackSubmit]="ButtonNamesGA.GlobalSearch"
  >
    <ng-template let-header pTemplate="header">
      <div [cpakTrackClick]="ButtonNamesGA.GlobalSearch" *ngIf="isShowTapToSearch" class="alc-tap-notification">
        {{ 'tapToSearch' | transloco }}
      </div>
    </ng-template>
    <ng-template let-group pTemplate="group">
      <div [cpakTrackClick]="ButtonNamesGA.GlobalSearch" class="p-d-flex p-ai-center" [className]="group.class">
        <span>{{ group.label }}</span>
      </div>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div [cpakTrackClick]="ButtonNamesGA.GlobalSearch" class="p-d-flex p-ai-center">
        <span class="suggestion-value">{{ item }}</span>
      </div>
    </ng-template>
  </p-autoComplete>
</div>
<p-confirmDialog></p-confirmDialog>
